"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsProducer = exports.useIsAccountManager = exports.usePermission = exports.useHasScope = exports.useHasAllScopes = exports.useHasAnyScope = void 0;
var auth_api_1 = require("@newfront-insurance/auth-api");
var react_provision_1 = require("@newfront-insurance/react-provision");
var scopes_1 = require("../scopes");
function useHasAnyScope(authProvider, scopes) {
    var _a;
    var user = (0, react_provision_1.useProvider)(authProvider).userDetails;
    if (!user) {
        return false;
    }
    return (0, scopes_1.hasAnyScope)((_a = user.scopes) !== null && _a !== void 0 ? _a : [], scopes);
}
exports.useHasAnyScope = useHasAnyScope;
function useHasAllScopes(authProvider, scopes) {
    var _a;
    var user = (0, react_provision_1.useProvider)(authProvider).userDetails;
    if (!user) {
        return false;
    }
    return (0, scopes_1.hasAllScopes)((_a = user.scopes) !== null && _a !== void 0 ? _a : [], scopes);
}
exports.useHasAllScopes = useHasAllScopes;
function useHasScope(authProvider, scope) {
    var _a;
    var user = (0, react_provision_1.useProvider)(authProvider).userDetails;
    if (!user) {
        return false;
    }
    return (0, scopes_1.hasScope)((_a = user.scopes) !== null && _a !== void 0 ? _a : [], scope);
}
exports.useHasScope = useHasScope;
function usePermission(authProvider, opts) {
    var scopes = opts.scopes, hasAll = opts.hasAll;
    var hasAnyScope = useHasAnyScope(authProvider, scopes);
    var hasAllScopes = useHasAllScopes(authProvider, scopes);
    if (hasAll) {
        return hasAllScopes;
    }
    return hasAnyScope;
}
exports.usePermission = usePermission;
function useIsAccountManager(authProvider) {
    return useHasScope(authProvider, auth_api_1.AuthRole.ACCOUNT_MANAGER);
}
exports.useIsAccountManager = useIsAccountManager;
function useIsProducer(authProvider) {
    return useHasScope(authProvider, auth_api_1.AuthRole.PRODUCER);
}
exports.useIsProducer = useIsProducer;
